<template>
  <message-bubble :isMine=isMine>
    <template>
      <span>[暂未支持的消息类型]</span>
    </template>
  </message-bubble>  
</template>

<script>
import MessageBubble from '../message-bubble'

export default {
  name: 'IllegalElement',
  components: {
    MessageBubble
  },
  props: {
    isMine: {
      type: Boolean
    }
  },
}
</script>